<template>
<header class="site-header" itemtype="https://schema.org/SiteNavigationElement" itemscope>
  <div class="site-container header-inner">
    <router-link class="brand" to="/" title="GB WhatsApp Guides" rel="home">
      <img class="brand-mark" src="@/assets/gbwhata-home.webp" alt="GB WhatsApp logo">
      <span class="brand-copy">
        <strong>GB Whata</strong>
        <small>APK guides</small>
      </span>
    </router-link>

    <nav class="desktop-nav" aria-label="Primary navigation">
      <router-link exact to="/">Home</router-link>
      <router-link to="/guide/">Guides</router-link>
      <router-link class="header-download" to="/download/">Download APK</router-link>
    </nav>

    <button class="menu-toggle" type="button" :aria-expanded="menuOpen ? 'true' : 'false'" aria-label="Toggle navigation" @click="menuOpen = !menuOpen">
      <img v-if="!menuOpen" src="@/assets/menu.svg" alt="">
      <img v-else src="@/assets/xmark-black.svg" alt="">
    </button>
  </div>

  <transition name="menu-fade">
    <nav v-if="menuOpen" class="mobile-nav" aria-label="Mobile navigation">
      <router-link exact to="/" @click.native="menuOpen = false">Home</router-link>
      <router-link to="/guide/" @click.native="menuOpen = false">Guides</router-link>
      <router-link to="/download/" @click.native="menuOpen = false">Download APK</router-link>
    </nav>
  </transition>
</header>
</template>

<script>
export default {
  name: 'HeadNav',
  data() {
    return {
      menuOpen: false,
    };
  },
  watch: {
    $route() {
      this.menuOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid rgba(217, 227, 220, 0.92);
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 8px 26px rgba(16, 37, 27, 0.06);
  backdrop-filter: blur(14px);
}

.header-inner {
  display: flex;
  min-height: 72px;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 11px;
  flex: 0 0 auto;
}

.brand-mark {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  object-fit: cover;
}

.brand-copy {
  display: grid;
  color: #13251e;
  line-height: 1.05;
}

.brand-copy strong {
  font-size: 17px;
  font-weight: 500;
}

.brand-copy small {
  margin-top: 4px;
  color: #62736b;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.desktop-nav {
  display: flex;
  align-items: center;
  gap: 25px;
}

.desktop-nav a {
  color: #30473d;
  font-size: 14px;
  font-weight: 500;
  transition: color 180ms ease;
}

.desktop-nav a:not(.header-download):hover,
.desktop-nav a:not(.header-download).router-link-active {
  color: #0d6b39;
}

.desktop-nav .header-download {
  min-height: 42px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #16a34a;
  box-shadow: 0 9px 20px rgba(22, 163, 74, 0.2);
  color: #ffffff;
}

.desktop-nav .header-download:hover,
.desktop-nav .header-download.router-link-active {
  background: #0d6b39;
  color: #ffffff;
}

.menu-toggle {
  display: none;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #d9e3dc;
  border-radius: 8px;
  background: #ffffff;
}

.menu-toggle img {
  width: 21px;
  height: 21px;
}

.mobile-nav {
  display: none;
}

.menu-fade-enter-active,
.menu-fade-leave-active {
  transition:
    opacity 160ms ease,
    transform 160ms ease;
}

.menu-fade-enter,
.menu-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

@media (max-width: 820px) {
  .desktop-nav {
    display: none;
  }

  .menu-toggle {
    display: inline-flex;
  }

  .mobile-nav {
    display: grid;
    gap: 2px;
    padding: 10px 14px 16px;
    border-top: 1px solid #e5ece7;
    background: #ffffff;
  }

  .mobile-nav a {
    padding: 12px 10px;
    border-radius: 8px;
    color: #30473d;
    font-size: 15px;
    font-weight: 500;
  }

  .mobile-nav a:hover,
  .mobile-nav a.router-link-active {
    background: #edf7ef;
    color: #0d6b39;
  }
}
</style>
